import * as R from 'ramda'

import ProductParamsCE from './ProductParamsCE'
import ProductParamsEV from './ProductParamsEV'
import ProductParamsPU from './ProductParamsPU'
import ProductParamsVA from './ProductParamsVA'

class Product {
    constructor({
        name = '',
        edition = '',
        industry = 'EV',
        portfolioId = null,
        productType = '',
        productUserIds = [],
        additionalTaxonomies = [],
        params = {},
        privilegedFields = {
            gender: '',
            intercept: true,
            qr: true,
            embed: true,
            onSite: false,
            customerJourney: true, // can't delete
        },
        mergefields = undefined,
        status,
    }, store) {
        this.name = name.replace(/&amp;/gi, '&')
        this.edition = (edition || '').replace(/&amp;/gi, '&')
        this.industry = industry
        this.portfolioId = portfolioId
        this.productType = productType
        this.mergefields = mergefields ? JSON.parse(mergefields) : undefined
        this.productUsers = productUserIds.reduce((map, userId) => {
            map[userId] = {
                selected: true,
            }
            return map
        }, {})

        if (this.industry === 'VA' && R.isEmpty(this.productType)) {
            this.productType = 'VAVA'
        }

        this.additionalTaxonomies = additionalTaxonomies.reduce((obj, ad) => {
            const { vocabularyId } = ad
            obj[vocabularyId] = ad
            return obj
        }, {})
        this.status = status

        this.privilegedFields = {
            gender: (privilegedFields.gender || ''),
            intercept: Boolean(privilegedFields.intercept),
            qr: Boolean(privilegedFields.qr),
            embed: Boolean(privilegedFields.embed),
            customerJourney: Boolean(privilegedFields.customerJourney),
        }

        if (!R.path(['userData', 'flags', 'isClientOnsite'], store)) {
            this.privilegedFields.onSite = Boolean(privilegedFields.onSite)
        }

        if (industry === 'EV') {
            this.params = new ProductParamsEV(params)
        } else if (industry === 'CE') {
            this.params = new ProductParamsCE(params)
        } else if (industry === 'PU') {
            this.params = new ProductParamsPU(params)
        } else if (industry === 'VA') {
            this.params = new ProductParamsVA(params)
        }
    }

    toJSON = () => {
        console.log(this.productUsers)
        const productUserIds = Object.keys(this.productUsers)
            .filter((userId) => R.pathOr(false, [userId, 'selected'])(this.productUsers))
            .map((id) => parseInt(id, 10))

        const additionalTaxonomyTermIds = Object.values(this.additionalTaxonomies)
            .map(({ termId }) => parseInt(termId, 10))

        const json = {
            name: this.name,
            edition: this.edition,
            industry: this.industry,
            portfolioId: this.portfolioId,
            productType: this.productType,
            productUserIds,
            additionalTaxonomyTermIds,
            privilegedFields: this.privilegedFields,
            mergefields: this.mergefields,
            status: this.status,
        }

        if (['EV', 'CE', 'PU', 'VA'].includes(this.industry)) {
            json.params = this.params.toJSON()
        } else if (this.industry === 'VENU') {
            json.params = {} // required on backend
        }

        if (['CO', 'VI'].includes(this.productType)) {
            json.isEventFree = Boolean(this.isEventFree)
        } else {
            json.isEventFree = false
        }

        return json
    }
}

export default Product
